/* import __COLOCATED_TEMPLATE__ from './scim-groups-bulk-update-details.hbs'; */
/* RESPONSIBLE TEAM: team-app-security */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import type AppAdminEvent from 'embercom/models/app-admin-event';

interface ScimGroupsBulkUpdateDetailsSignature {
  Args: {
    event: AppAdminEvent;
  };
}

export default class ScimGroupsBulkUpdateDetails extends Component<ScimGroupsBulkUpdateDetailsSignature> {
  @tracked showModal = false;

  @action
  toggleModal() {
    this.showModal = !this.showModal;
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'TableCells::AdminEvents::ScimGroupsBulkUpdateDetails': typeof ScimGroupsBulkUpdateDetails;
    'table-cells/admin-events/scim-groups-bulk-update-details': typeof ScimGroupsBulkUpdateDetails;
  }
}
